import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/use-auth";
import { Redirect, useLocation } from "wouter";
import { Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MFASetup } from "@/components/mfa/mfa-setup";

export default function MFASetupPage() {
  const { user, isLoading } = useAuth();
  const [, setLocation] = useLocation();
  const [setupComplete, setSetupComplete] = useState(false);

  // If loading, show loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Redirect to="/login" />;
  }

  // If setup is complete, redirect back to profile
  useEffect(() => {
    if (setupComplete) {
      // Short delay to allow user to see completion message
      const timer = setTimeout(() => {
        setLocation('/profile?tab=security');
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [setupComplete, setLocation]);

  return (
    <div className="container max-w-4xl py-8 px-4 sm:px-6 md:py-12">
      <div className="mb-6">
        <Button 
          variant="ghost" 
          className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 p-0"
          onClick={() => setLocation('/profile?tab=security')}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Security Settings
        </Button>
      </div>
      
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Two-Factor Authentication Setup</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Secure your account with an additional layer of protection
        </p>
      </div>
      
      <MFASetup 
        onComplete={() => setSetupComplete(true)}
        onCancel={() => setLocation('/profile?tab=security')}
      />
    </div>
  );
}